import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePen, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import Modal from "../modal/modal";
import FileLeave from "../modal/leave-modals/FIleLeave";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { GET_USER_LEAVE_CRED_DATA } from "../../../config/config";
import { useAuth } from "../../../services/auth-services/authContext";
import { AuthContextState } from "../../../utils/types";
import { AxiosError } from "axios";
import LeaveDetails from "../modal/leave-modals/LeaveDetails";

interface leaveRequestByIdProps {
    id : number;
    days_on_leave : number; 
    leave_type : string;
    leave_dates : string;
    status : string;
}

interface empleaveCreditsProps {
    emp_id : number;
    fullname : string;
    total_leave : number;
    earned_vl : number;
    total_vl : number;
    total_sl : number;
    used_vl : number;
    used_sl : number;
    remaining_vl : number;
    remaining_sl : number;
}

const LeaveTab = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);
    const [leaveData, setLeaveData] = useState<empleaveCreditsProps | null>(null);
    const [leaveRequest, setLeaveRequest] = useState<leaveRequestByIdProps[] | null>(null);
    const createModalContent = (content : React.JSX.Element) =>{
        setModalChildren(content);
        setShowModal(true);
    }
    const { decodedJwtData } = useAuth() as AuthContextState; 
    const account_id = decodedJwtData?.userId;

    const formatDate = (dateString: string | undefined): string => {
        if(!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    const handleShowLeaveDetailsModal = (id : number) => {
        setModalChildren(<LeaveDetails id={id} />);
        setShowModal(true);
    }

    useEffect(()=>{
        const loadLeaveCred = async() => {
            try{
                const cred_res = await api.get(GET_USER_LEAVE_CRED_DATA+account_id,{
                    headers: { 'Authorization': 'Bearer ' + getToken() }
                });
                const leave_data = cred_res.data as {leave_cred : empleaveCreditsProps[], annual_leave_req : leaveRequestByIdProps[] };
                setLeaveData(leave_data.leave_cred[0]);
                setLeaveRequest(leave_data.annual_leave_req);
            }catch(e){
                const error = e as AxiosError;
                if(error.response?.status === 401){
                    alert('login session expired!')
                }else{
                    alert('Something went wrong!')
                }
            }
        }
        if(!showModal) loadLeaveCred();
    },[account_id, showModal]);

    return (
        <div className="content flex">
            <Helmet>
                <title>Leave</title>
            </Helmet>
            <SideBar />
            <div className='main-content'>
                <div className="flex flex-col gap-2">
                    <div className="w-full flex gap-4 bg-white shadow p-4 text-gray-600">
                        <div>
                            <h1 className="text-xl">Leave</h1>
                        </div>
                        <div className="ms-auto">
                            <button type="button" onClick={()=>createModalContent(<FileLeave />)} className="button button-vcc-green text-sm">
                                <FontAwesomeIcon icon={faFilePen} /> &nbsp;
                                File Leave
                            </button>
                        </div>
                    </div>
                    <div className="flex gap-4 w-full">
                        <div className="bg-white w-full flex shadow">
                            <div className="bg-orange-500 w-1 h-full"></div>
                            <div className="flex flex-col gap-2 justify-center items-center w-full text-gray-600 py-2">
                                <div>
                                    <p className="text-orange-500 uppercase font-medium">
                                        Total Leave Credits
                                    </p>
                                </div>
                                <div className="flex w-full">
                                    <div className="w-full text-center">
                                        <p>VL</p>
                                        <div className="flex justify-center">
                                            {leaveData ? (
                                                <>
                                                    <h1 className="text-4xl font-semibold">{leaveData.total_vl}</h1>
                                                    <p className="text-green-500 font-medium text-lg">+{leaveData.earned_vl}</p>
                                                </>
                                            ) : (
                                                <h1 className="text-4xl font-semibold">
                                                    <FontAwesomeIcon icon={faSpinner} className="text-blue-500 animate-spin" />
                                                </h1>
                                            )}
                                            
                                        </div>
                                    </div>
                                    <div className="w-1 bg-orange-500"></div>
                                    <div className="w-full text-center">
                                        <p>SL</p>
                                        <div className="text-center">
                                            {leaveData ? (<h1 className="text-4xl font-semibold">{leaveData.total_sl}</h1>) : (
                                                <h1 className="text-4xl font-semibold">
                                                    <FontAwesomeIcon icon={faSpinner} className="text-blue-500 animate-spin" />
                                                </h1>
                                            )}
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white w-full flex shadow">
                            <div className="bg-orange-500 w-1 h-full"></div>
                            <div className="flex flex-col gap-2 justify-center items-center w-full text-gray-600 py-2">
                                <div>
                                    <p className="text-orange-500 uppercase font-medium">
                                        Converted leave Credits
                                    </p>
                                </div>
                                <div className="flex w-full">
                                    <div className="w-full text-center">
                                        <div>
                                            <p>Converted SL from last year</p>
                                        </div>
                                        <div className="text-center">
                                            <h1 className="text-4xl font-semibold">{leaveData ? leaveData.earned_vl : (<FontAwesomeIcon icon={faSpinner} className="text-blue-500 animate-spin" />)}</h1>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="bg-white w-full flex shadow">
                            <div className="bg-orange-500 w-1 h-full"></div>
                            <div className="flex flex-col gap-2 justify-center items-center w-full text-gray-600 py-2">
                                <div>
                                    <p className="text-orange-500 uppercase font-medium">
                                        Used Leave Credits
                                    </p>
                                </div>
                                <div className="flex w-full">
                                    <div className="w-full text-center">
                                        <p>VL</p>
                                        <div className="text-center">
                                            <h1 className="text-4xl font-semibold">
                                                {leaveData ? leaveData.used_vl : (<FontAwesomeIcon icon={faSpinner} className="text-blue-500 animate-spin" />)}
                                            </h1>
                                        </div>
                                    </div>
                                    <div className="w-1 bg-orange-500"></div>
                                    <div className="w-full text-center">
                                        <p>SL</p>
                                        <div className="text-center">
                                            <h1 className="text-4xl font-semibold">
                                                {leaveData ? leaveData.used_sl : (<FontAwesomeIcon icon={faSpinner} className="text-blue-500 animate-spin" />)}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white w-full flex shadow">
                            <div className="bg-orange-500 w-1 h-full"></div>
                            <div className="flex flex-col gap-2 justify-center items-center w-full text-gray-600 py-2">
                                <div>
                                    <p className="text-orange-500 uppercase font-medium">
                                        Remaining Leave Credits
                                    </p>
                                </div>
                                <div className="flex w-full">
                                    <div className="w-full text-center">
                                        <p>VL</p>
                                        <div className="text-center">
                                            <h1 className="text-4xl font-semibold text-green-500">
                                                {leaveData ? (leaveData.total_vl + leaveData.earned_vl) - leaveData.used_vl : (<FontAwesomeIcon icon={faSpinner} className="text-blue-500 animate-spin" />)}
                                            </h1>
                                        </div>
                                    </div>
                                    <div className="w-1 bg-orange-500"></div>
                                    <div className="w-full text-center">
                                        <p>SL</p>
                                        <div className="text-center">
                                            <h1 className="text-4xl font-semibold text-green-500">
                                                {leaveData ? (leaveData.total_sl) - leaveData.used_sl : (<FontAwesomeIcon icon={faSpinner} className="text-blue-500 animate-spin" />)}
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="table-container h-full shadow">
                            <table className="w-full h-full border">
                                <thead className="table-fixed-header border">
                                    <tr className="bg-gray-100">
                                        <th className='table-headers font-medium'>#</th>
                                        <th className='table-headers font-medium max-w-14'>No. of Days</th>
                                        <th className='table-headers font-medium'>Leave type</th>
                                        <th className='table-headers font-medium max-w-9'>Date/s on leave</th>
                                        <th className='table-headers font-medium max-w-10'>Status</th>
                                        <th className='table-headers font-medium'>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {leaveRequest ? leaveRequest.map((data, index) => (
                                        <tr className="hover:bg-gray-300">
                                            <td className='table-body px-2'>{index + 1}</td>
                                            <td className='table-body px-2'>{data.days_on_leave}</td>
                                            <td className='table-body px-2'>{data.leave_type === 'vl' ? "Vacation Leave" : "Emergency/Sick Leave"}</td>
                                            <td className='table-body px-2 text-center'>
                                                <div className="flex flex-wrap gap-1 justify-center items-center">
                                                    {(JSON.parse(data.leave_dates) as string[]).map((date, idx) => (
                                                        <div key={idx} className="bg-orange-200 rounded shadow px-2">{formatDate(date)}</div>
                                                    ))}
                                                </div>
                                            </td>
                                            <td className='table-body px-2 text-sm uppercase'>
                                                <p className={data.status === 'Approved' ? 'bg-green-400 rounded text-white' : data.status === 'Pending' ? 'bg-yellow-500 rounded text-white' : 'bg-red-400 rounded text-white'}>
                                                    {data.status}
                                                </p>
                                            </td>
                                            <td className='table-body px-2'>
                                                <div>
                                                    <button type="button" onClick={()=>handleShowLeaveDetailsModal(data.id)} className="underline text-blue-500">
                                                        view
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))  : Array.from({length : 3}).map((_, index) => (
                                        <tr key={index}>
                                            {[...Array(6)].map((_, colIndex) => (
                                                <td key={colIndex} className='table-body'>
                                                    <div className="table-loading bg-gray-200"></div>
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {showModal &&(
                <Modal onClose={()=>setShowModal(false)}> 
                    {modalChildren}
                </Modal>
            )}
        </div>
    )
}

export default LeaveTab;